import App from "./src/App";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./src/components/ErrorBoundary";
import { initWhitelabel } from "./src/lib/whitelabel";
import "./src/theme.css";

// Apply cached whitelabel branding (favicon) before first paint.
initWhitelabel();

// Load DOM inspector in development only
if (import.meta.env.DEV) {
  import("./src/visual-inspector.js").catch(() => {});
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);